import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@app-environment';
import { Observable, switchMap } from 'rxjs';
import { CreateTrackingDto, TrackingDto } from '@scf-monorepo/backend-lib/dtos';
import { ISignedURL } from '@scf-monorepo/interfaces';

@Injectable({
    providedIn: 'root'
})
export class TrackingService {
    private http = inject(HttpClient);

    /**
     * Track visits to the application
     *
     * @param {CreateTrackingDto} trackingData The data to be tracked
     * @returns {Observable<TrackingDto>} An observable containing the tracking entry
     */
    public addTracking(trackingData: CreateTrackingDto): Observable<TrackingDto> {
        return this.http.post<TrackingDto>(`${environment.gatewayAPI}/tracking`, trackingData);
    }

    /**
     * Get tracking data for a specific month in CSV format.
     *
     * @param {string} monthId The ID of the month for which to retrieve the tracking data.
     * @returns {Observable<string>} An observable containing the CSV data.
     */
    public getTrackingCSV(monthId: string): Observable<string> {
        return this.http
            .get<ISignedURL>(`${environment.gatewayAPI}/tracking/${monthId}`)
            .pipe(switchMap(({ signedURL }) => this.http.get(signedURL, { responseType: 'text' })));
    }
}
